var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomerDetail',_vm._b({key:_vm.id,ref:"detail",attrs:{"id":_vm.id}},'CustomerDetail',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }